import { FileInfoDto } from '@core/models/file-info.dto';

export const FILES: FileInfoDto[] = [
  { displayName: 'Test', description: 'Dies ist ein test.', link: '', size: 4398563, date: '2020-03-24T06:44:59.457Z' },
  { displayName: 'Test2', description: 'Dies ist ein test.', link: '', size: 4398563, date: '2020-03-24T06:44:59.457Z' },
  { displayName: 'Test3', description: 'Dies ist ein test.', link: '', size: 4398563, date: '2020-03-24T06:44:59.457Z' },
  { displayName: 'Test4', description: 'Dies ist ein test.', link: '', size: 4398563, date: '2020-03-24T06:44:59.457Z' },
  { displayName: 'Test5', description: 'Dies ist ein test.', link: '', size: 4398563, date: '2020-03-24T06:44:59.457Z' },
];
